var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcPrevious = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#3f68b5;}.c{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M15.422-7.369l-4.614-4.614L15.422-16.6l-1.4-1.4L8-11.982l6.018,6.018Z",
  transform: "translate(-9 18)"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1326 -854)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "b",
  width: 30,
  height: 30,
  rx: 4,
  transform: "translate(1326 854)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1337.187 863.058)"
}, /*#__PURE__*/React.createElement("g", {
  className: "c",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M3-.935H20.451V-23H3Z",
  transform: "translate(-8.015 17.985)"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcPrevious);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_previous.7155b963bd653438d23509a772d24764.svg";